import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_API_URL}/api/company`;

export const fetchAllCompaniesApi = async () => {
  const response = await axios.get(API_BASE_URL);
  return response;
};

export const addNewCompanyApi = async (companyData) => {
  const response = await axios.post(API_BASE_URL, companyData);
  return response;
};

export const fetchCompanyDetailsApi = async (companyid) => {
  const body = { companyID: companyid };
  const response = await axios.post(`${API_BASE_URL}/getCompanyDetails`, body);
  return response;
};

export const editCompanyApi = async (companyData) => {
  const response = await axios.put(API_BASE_URL, companyData);
  return response;
};
